// Live art reprint (follow-up C): a logo replace / under-logo caption edit on a
// SELLING store is saved and marked in teamStores.liveArtPending, then
// reprinted in place by v4 (POST /reprint-logos mode 'art'). The server shapes
// are in routes/teamstores.js (replace / text / live-art/approve); this file is
// the browser's reading of them.

export type LiveArtPending = {
  logoIds?: string[];
  reasons?: Record<string, string>;
  since?: string | null;
};

/** What staff are told before approving. Same sentence as the other dashboards. */
export const APPROVE_WARNING = 'This swaps the main image on every logo product — the store stays online.';

/** The logo ids still waiting for "Approve for live" (tolerant of a bad doc). */
export function pendingLogoIds(p: LiveArtPending | null | undefined): string[] {
  const ids = p && Array.isArray(p.logoIds) ? p.logoIds : [];
  return ids.filter((id): id is string => typeof id === 'string' && id.length > 0);
}

export function reasonLabel(reason: string | undefined): string {
  return reason === 'text_changed' ? 'caption changed' : 'logo replaced';
}

export type EditOutcome = { kind: 'success' | 'info' | 'warning'; message: string };

type EditBody = {
  success?: boolean;
  partial?: boolean;
  pendingLive?: boolean;
  message?: string;
  error?: string;
  reprint?: { complete?: boolean } | null;
} | null | undefined;

/**
 * Reads a replace / text answer from a SELLING store. null = a plain edit
 * (store not selling): the caller shows its usual toast.
 *  - saved, waiting for approval            -> info
 *  - text saved, reprint did not finish (207) -> warning (never read as success)
 *  - text saved and reprinted               -> success
 */
export function describeLiveEdit(body: EditBody): EditOutcome | null {
  if (!body) return null;
  if (body.partial === true || (body.success === false && body.pendingLive === true)) {
    return { kind: 'warning', message: body.message || body.error || 'Saved, but the live reprint did not finish.' };
  }
  if (body.pendingLive === true) {
    return { kind: 'info', message: body.message || 'Saved. The store keeps selling the old print until you approve the new art for live.' };
  }
  if (body.reprint && body.reprint.complete === true && body.message) {
    return { kind: 'success', message: body.message };
  }
  return null;
}
